import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { MainStore } from 'src/app/common/main.store';
import { CustomerService } from '../customer.service';
import { ErrorService } from '../../../common/errors/error.service';
import { CustomerCanDeleteResponse, CustomerMasterData } from '../customer.model';

@Component({
    selector: 'app-customer-delete',
    templateUrl: './customer-delete.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './customer-delete.component.scss'
})
export class CustomerDeleteComponent {

  @Input() kundeid: number = -1;
  
  isLoading: boolean = false;
  loadingText: string = 'Undersøger..';
  customer: CustomerMasterData = {} as CustomerMasterData;
  canDeleteCustomer: CustomerCanDeleteResponse = {} as CustomerCanDeleteResponse;

  deleteCaption: string = 'Slet';
  deleteMesaage: string = '';
  arkiverCustomer: boolean = false;
  isDeletingCustomer: boolean = false;

  constructor(
    public activeModal: NgbActiveModal,
    private route: ActivatedRoute,
    private router: Router,
    private toastrService: ToastrService,
    private customerService: CustomerService,
    private store: MainStore,
    private errorService: ErrorService

  ) { }

  async ngOnInit(): Promise<void> {
    if (Number.isSafeInteger(this.kundeid) == false) {
      this.errorService.notify('KundeId ['+ this.kundeid + '] er ikke et gyldigt kundeId');
      this.router.navigate(['/home']);
    }
    else
    {
      const isAdmin = this.store.currentUser.get().isAdmin;
      this.isLoading = true;
      this.customer = await this.customerService.getCustomer(this.kundeid);
      if (this.customer != null)
      {
        if (! isAdmin && this.customer.departmentId != this.store.currentUser.get().departmentId) 
        {
            this.errorService.notify('Du har ikke rettigheder til at slette kunde med id: ['+ this.route.snapshot.paramMap.get('kundeid') + ']', { tier: 'modal' });
            this.activeModal.dismiss('Cross click');
            return;
        }

        this.loadingText = 'Undersøger om kunde ' + this.customer.name + ' kan slettes..';
        this.canDeleteCustomer = await this.customerService.canDeleteCustomer(this.kundeid);
        
        if (this.canDeleteCustomer.canDelete == false)
        {
          this.errorService.notify('Kunde ' + this.customer.name + ' kan ikke slettes: ' + this.canDeleteCustomer.message);
          this.activeModal.dismiss('Cross click');
          return;
        }

      this.deleteCaption = 'Slet [' + this.customer.name + '] ?';
       if (this.canDeleteCustomer.noOfCommpanies > 0 && this.canDeleteCustomer.message != '')
       {
          this.deleteCaption = 'Gør [' + this.customer.name + '] inaktiv ?';
          this.deleteMesaage = this.canDeleteCustomer.message;
          this.arkiverCustomer = true;
       }
      }
      else
      {
        this.errorService.notify('KundeId ['+ this.route.snapshot.paramMap.get('kundeid') + '] findes ikke / er ikke aktiv');
        this.activeModal.dismiss('Cross click');
      }

      this.isLoading = false;
    }
  }

  async deleteCustomer(): Promise<void>
  {
    this.isDeletingCustomer = true;
    await this.customerService.deleteCustomer(this.kundeid)
    .then( ()=> {
      if (this.arkiverCustomer)
      {
        this.toastrService.success('Kunde ' + this.customer.name + ' er gjort inaktiv');
      }
      else
      {
        this.toastrService.success('Kunde ' + this.customer.name + ' er slettet');
      }
      this.activeModal.close('Close click');
      this.router.navigate(['/customers']);
    })
    .catch( (response) => {
      this.isDeletingCustomer = false;
    });
  }
}
